module.exports = {"id":"142499","name":"Aitor Sanz","rating":"75","photo":"./data/images/photos/2/142499.png","club":{"name":"CD Tenerife","logo":"./data/images/clubs/CDTenerife.png"},"positions":["MDC","MC","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AitorSanz0.json
// module id = 142
// module chunks = 0